import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const SecurityFeatures = ({ showCaptcha = false, onCaptchaVerify }) => {
  const [captchaValue, setCaptchaValue] = useState('');
  const [captchaChallenge, setCaptchaChallenge] = useState('');
  const [captchaError, setCaptchaError] = useState('');
  const [captchaAnswer, setCaptchaAnswer] = useState(0);

  // Generate simple math captcha
  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    const operators = ['+', '-'];
    const operator = operators?.[Math.floor(Math.random() * operators?.length)];
    
    let result;
    if (operator === '+') {
      result = num1 + num2;
    } else {
      result = num1 - num2;
    }
    
    setCaptchaChallenge(`${num1} ${operator} ${num2} = ?`);
    return result;
  };

  useEffect(() => {
    if (showCaptcha) {
      setCaptchaAnswer(generateCaptcha());
    }
  }, [showCaptcha]);

  const handleCaptchaChange = (e) => {
    const value = e?.target?.value;
    setCaptchaValue(value);
    setCaptchaError('');
    
    if (value && parseInt(value) === captchaAnswer) {
      onCaptchaVerify?.(true);
    } else {
      onCaptchaVerify?.(false);
    }
  };

  const refreshCaptcha = () => {
    setCaptchaValue('');
    setCaptchaAnswer(generateCaptcha());
    setCaptchaError('');
    onCaptchaVerify?.(false);
  };

  if (!showCaptcha) {
    return (
      <div className="bg-muted/30 border border-border rounded-md p-4">
        <div className="flex items-start space-x-3">
          <Icon name="Shield" size={20} className="text-success mt-0.5" />
          <div className="flex-1">
            <h4 className="text-sm font-medium text-foreground mb-1">
              Secure Login
            </h4>
            <p className="text-xs text-muted-foreground">
              Your login is protected with industry-standard encryption and security measures.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-warning/10 border border-warning/20 rounded-md p-4">
      <div className="flex items-start space-x-3 mb-3">
        <Icon name="AlertTriangle" size={20} className="text-warning mt-0.5" />
        <div className="flex-1">
          <h4 className="text-sm font-medium text-foreground mb-1">
            Security Verification Required
          </h4>
          <p className="text-xs text-muted-foreground">
            Please complete the verification below to continue.
          </p>
        </div>
      </div>
      
      <div className="flex items-center space-x-3">
        <div className="flex items-center space-x-2 bg-background border border-border rounded px-3 py-2">
          <span className="text-sm font-mono text-foreground">
            {captchaChallenge}
          </span>
        </div>
        
        <input
          type="number"
          value={captchaValue}
          onChange={handleCaptchaChange}
          placeholder="Answer"
          className="w-20 px-3 py-2 border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
        />
        
        <button
          type="button"
          onClick={refreshCaptcha}
          className="p-2 text-muted-foreground hover:text-foreground transition-colors duration-150"
          title="Refresh captcha"
        >
          <Icon name="RotateCcw" size={16} />
        </button>
      </div>
      
      {captchaError && (
        <p className="text-xs text-error mt-2">{captchaError}</p>
      )}
    </div>
  );
};

export default SecurityFeatures;